import Lenis from 'lenis';
import { initAreaReveal } from './area-reveal.js';
import { siteMotion } from './site-motion.js';
import { initWorksNavigation } from './works-navigation.js';
import { initMoviePlayback } from './movie-playback.js';

const root = document.querySelector('.works-collection');
const lenis = new Lenis({ autoRaf: true, smoothWheel: false, respectReducedMotion: false });
const destroyNavigation = initWorksNavigation(root, lenis);
const destroyReveal = initAreaReveal(root.querySelectorAll('.service-title, .service-intro-copy, .work-entry-media, .work-entry-copy, .work-entry-shots > figure'), {
  root: null, reducedMotion: siteMotion,
});
const movieCleanups = [...root.querySelectorAll('.work-entry-video')].map((area) => initMoviePlayback(area, { reducedMotion: siteMotion }));
const destroyMovies = () => movieCleanups.forEach((cleanup) => cleanup());
window.addEventListener('pagehide', destroyReveal, { once: true });
if (import.meta.hot) import.meta.hot.dispose(() => {
  window.removeEventListener('pagehide', destroyReveal);
  destroyMovies();
  destroyNavigation();
  destroyReveal();
  lenis.destroy();
});
